import moment from "moment";

const services = {
    auth: (window.location.protocol !== "https:" ? "http://" : "https://") + (window.location.hostname === "localhost" ? "localhost:8081" : window.location.hostname + (window.location.port !== 80 && window.location.port !== 443 ? ":" + window.location.port : "")) + "/authapi/",
    ilearning: (window.location.protocol !== "https:" ? "http://" : "https://") + (window.location.hostname === "localhost" ? "localhost:8080" : window.location.hostname + (window.location.port !== 80 && window.location.port !== 443 ? "" + "" : "")) + "/ilearning/",
    udemy: (window.location.protocol !== "https:" ? "http://" : "https://") + (window.location.hostname === "localhost" ? "localhost:8080" : window.location.hostname + (window.location.port !== 80 && window.location.port !== 443 ? "" + "" : "")) + "/udemy/"
}

export const convertDateTimeFromServer = date => (date ? moment(date).format(APP_LOCAL_DATETIME_FORMAT) : null);

export const convertDateTimeWithFormat = (date, format) => (date ? moment(date).format(format) : null);

export const SERVER_URL = services['ilearning'];

export const FILE_URL = services['ilearning'] + 'file/getFileByName/';

export const APP_DATE_FORMAT = 'DD/MM/YYYY HH:mm';
export const APP_TIMESTAMP_FORMAT = 'DD/MM/YYYY HH:mm:ss';
export const APP_LOCAL_DATE_FORMAT = 'DD/MM/YYYY';
export const APP_LOCAL_DATETIME_FORMAT = 'YYYY-MM-DDThh:mm';

export const AUTHORIZATION_HEADER = 'Authorization';

export const PHONE = '+903223386084';
export const PHONE_STRING = '+90 322 338 60 84 - 2074';
export const EMAIL = 'cuyzakademi@gmail.com';
export const ADDRESS = 'Balcalı Kampüsü:\n' +
    'Çukurova Üniversitesi Endüstri Mühendisliği Bölümü 01250,\n' +
    'Sarıçam / Adana, TÜRKİYE';



export const breakpoint = {
    xsm: '0',
    // Small screen / phone
    sm: '576',
    // Medium screen / tablet
    md: '768',
    // Large screen / desktop
    lg: '992',
    // Extra large screen / wide desktop
    xl: '1200',
    // Extra Extra large screen / wide desktop
    xxl: '1400'
};
export const breakpointpx = {
    xsm: '0',
    // Small screen / phone
    sm: '576px',
    // Medium screen / tablet
    md: '768px',
    // Large screen / desktop
    lg: '992px',
    // Extra large screen / wide desktop
    xl: '1200px',
    // Extra Extra large screen / wide desktop
    xxl: '1400px'
};